import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import ProrrogacaoMOTRealizadaStore from "../stores/ProrrogacaoMOTRealizadaStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomPieChart} from "../../comum/components/CustomPieChart";

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'EMPRESA', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM'];

@inject("store")
@DataWrapper
@observer
export class ProrrogacaoMOTRealizada extends Component {
    constructor(props) {
        super(props);
        this.controller = new ProrrogacaoMOTRealizadaStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Prorrogações de MOT realizadas");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                location={this.props.location}
                                controller={this.controller}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomPieChart data={this.controller.dados} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
